import { useRandomAsset } from "../../hooks/useRandomAsset"
import { usePluginConfig } from "../../contexts/pluginContext"

const EventDetailsPromotionalAsset = ({utmSource, utmMedium, utmCampaign, customAdClasses}) => {
  const pluginConfig = usePluginConfig();
  const publisherSettings = pluginConfig.publisherSettings;

  // We use the event_list because we don't have specific promotional assets for the event detail page
  const promotionalAsset = useRandomAsset('event_list');

  if (!promotionalAsset) {
    return null;
  }

  const promoteUrl =
    `${process.env.EVVNT_FORM_URL}?` +
    `partner=${publisherSettings.api_key}&publisher_id=${publisherSettings.publisher?.id}` +
    `&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;

  return (
    <div className={`flex items-center justify-center evvnt-ad`}>
      <a href={promoteUrl} target="_blank" rel="noopener">
        <img src={promotionalAsset.image_url} className={customAdClasses}
             alt="Promote your event" />
      </a>
    </div>
  );
};

export default EventDetailsPromotionalAsset;
